<router-outlet></router-outlet>
<app-redirect></app-redirect>
<ngx-ui-loader></ngx-ui-loader>
<flow-sync-document-viewer-modal></flow-sync-document-viewer-modal>
